// path: /src/config/config-firebase.js
import { initializeApp, getApps } from "firebase/app";
import { getAuth } from "firebase/auth";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  // Your web app's Firebase configuration here
  // See https://firebase.google.com/docs/web/setup#add-sdks-initialize
  // apiKey: 'API_KEY',
  // authDomain: 'PROJECT_ID.firebaseapp.com',
  // databaseURL: 'https://PROJECT_ID.firebaseio.com',
  // projectId: 'PROJECT_ID',
  // storageBucket: 'PROJECT_ID.appspot.com',
  // messagingSenderId: 'SENDER_ID',
  // appId: 'APP_ID',
  // measurementId: 'G-MEASUREMENT_ID'
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase Authentication and export it
export const auth = getAuth(app);

// A second, isolated Firebase app instance sharing the same project config.
// Firebase Auth only supports one active user per app instance, so any flow
// that needs to authenticate a DIFFERENT user (e.g. verifying a team
// member's own phone OTP) while the merchant stays logged in on `auth` must
// run against this instance instead — otherwise it would sign the merchant
// out and replace their session with the team member's.
const SECONDARY_APP_NAME = "secondary";
export const getSecondaryAuth = () => {
  const existing = getApps().find((a) => a.name === SECONDARY_APP_NAME);
  const secondaryApp = existing ?? initializeApp(firebaseConfig, SECONDARY_APP_NAME);
  return getAuth(secondaryApp);
};
